import { render, staticRenderFns } from "./IlamTipiPicker.vue?vue&type=template&id=1e564a8a"
import script from "./IlamTipiPicker.vue?vue&type=script&lang=ts"
export * from "./IlamTipiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports